import { supabase } from '../supabase/supabaseClient';

export const uploadFileAndGetUrl = async (file, identifier, folderPath = '', bucketName = 'uploads') => {
  try {
    const timestamp = Date.now();
    const ext = file.name.split('.').pop();
    const cleanName = identifier.replace(/\s+/g, '_');
    const fileName = `${cleanName}_${folderPath}_${timestamp}.${ext}`;
    const fullPath = folderPath ? `${fileName}` : fileName;

    //2. Upload
    const { data, error } = await supabase.storage
      .from(bucketName)
      .upload(fullPath, file, {
        contentType: file.type || 'application/octet-stream',
        // upsert: true,
      });

    // 3. Return URL path dari file
    return fullPath;
  } catch (err) {
    console.error('Upload Error:', err);
    return null;
  }
};

export const getPhotoUrl = async (filename) => {
  if (!filename) return '../assets/photo-profile/profile.png';

  const { data, error } = await supabase
    .storage
    .from('uploads')
    .createSignedUrl(filename, 3600); // URL berlaku 3600 detik

  if (error || !data?.signedUrl) {
    console.error('Error getting signed URL:', error?.message);
    return '../assets/photo-profile/profile.png';
  }

  return data.signedUrl;
};

export const deleteFileFromBucket = async (filePath, bucketName = 'uploads') => {
  if (!filePath) return;

  const { error } = await supabase.storage
    .from(bucketName)
    .remove([filePath]);

  if (error) {
    console.error('Delete file error:', error.message);
  }
};
